import "regenerator-runtime/runtime.js";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { SelectionManager, useMultipleSelectionState } from "@react-stately/selection";
import _react, { useEffect, useMemo } from "react";
import { Section, useCollection } from "@react-stately/collections";
export { Section };
var $d7f61bffc1886b961473c48c52f8fd$var$_Symbol$iterator;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $d7f61bffc1886b961473c48c52f8fd$var$ROW_HEADER_COLUMN_KEY = 'row-header-column-' + Math.random().toString(36).slice(2);
$d7f61bffc1886b961473c48c52f8fd$var$_Symbol$iterator = Symbol.iterator;

var $d7f61bffc1886b961473c48c52f8fd$export$TableCollection = /*#__PURE__*/function () {
  function $d7f61bffc1886b961473c48c52f8fd$export$TableCollection(nodes, prev, opts) {
    var _this = this;

    _classCallCheck(this, $d7f61bffc1886b961473c48c52f8fd$export$TableCollection);

    this.keyMap = void 0;
    this.headerRows = void 0;
    this.columns = void 0;
    this.rowHeaderColumnKeys = void 0;
    this.body = void 0;
    this.keyMap = new Map(prev == null ? void 0 : prev.keyMap) || new Map();
    this.columns = [];
    this.rowHeaderColumnKeys = new Set(); // Add cell for selection checkboxes if needed.

    if (opts == null ? void 0 : opts.showSelectionCheckboxes) {
      var rowHeaderColumn = {
        type: 'column',
        key: $d7f61bffc1886b961473c48c52f8fd$var$ROW_HEADER_COLUMN_KEY,
        value: null,
        textValue: '',
        level: 0,
        index: 0,
        hasChildNodes: false,
        rendered: null,
        childNodes: [],
        props: {
          isSelectionCell: true
        }
      };
      this.keyMap.set(rowHeaderColumn.key, rowHeaderColumn);
      this.columns.unshift(rowHeaderColumn);
    }

    var visit = function visit(node) {
      // If the node is the same object as the previous node for the same key,
      // we can skip this node and its children. We always visit columns though,
      // because we depend on order to build the columns array.
      var prevNode = _this.keyMap.get(node.key);

      if (node.type !== 'column' && node === prevNode) {
        return;
      }

      _this.keyMap.set(node.key, node);

      if (node.type === 'column' && !node.hasChildNodes) {
        _this.columns.push(node);

        if (node.props.isRowHeader) {
          _this.rowHeaderColumnKeys.add(node.key);
        }
      }

      if (node.type === 'cell') {
        node.column = _this.columns[node.index];
      }

      var childKeys = new Set();
      var last;

      var _iterator = _createForOfIteratorHelper(node.childNodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _child = _step.value;
          childKeys.add(_child.key);

          if (last) {
            last.nextKey = _child.key;
            _child.prevKey = last.key;
          } else {
            _child.prevKey = null;
          }

          visit(_child);
          last = _child;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (last) {
        last.nextKey = null;
      } // Remove deleted nodes and their children from the key map


      if (prevNode) {
        var _iterator2 = _createForOfIteratorHelper(prevNode.childNodes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var child = _step2.value;

            if (!childKeys.has(child.key)) {
              remove(child);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };

    var remove = function remove(node) {
      _this.keyMap.delete(node.key);

      var _iterator3 = _createForOfIteratorHelper(node.childNodes),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;

          if (_this.keyMap.get(child.key) === child) {
            remove(child);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };

    var bodyKeys = new Set();
    var last;

    var _iterator4 = _createForOfIteratorHelper(nodes),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var node = _step4.value;

        if (last) {
          last.nextKey = node.key;
          node.prevKey = last.key;
        } else {
          node.prevKey = null;
        }

        visit(node);

        if (node.type !== 'column') {
          bodyKeys.add(node.key);
        }

        if (node.type === 'body') {
          this.body = node;
        }

        last = node;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    if (last) {
      last.nextKey = null;
    } // Default row header column to the first one.


    if (this.rowHeaderColumnKeys.size === 0) {
      this.rowHeaderColumnKeys.add(this.columns[(opts == null ? void 0 : opts.showSelectionCheckboxes) ? 1 : 0].key);
    }

    this.headerRows = this.buildHeaderRows();
  }

  _createClass($d7f61bffc1886b961473c48c52f8fd$export$TableCollection, [{
    key: "buildHeaderRows",
    value: function buildHeaderRows() {
      var _this2 = this;

      var columns = [];
      var seen = new Map();

      var _iterator5 = _createForOfIteratorHelper(this.columns),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _column = _step5.value;
          var parentKey = _column.parentKey;
          var col = [_column];

          while (parentKey) {
            var parent = this.keyMap.get(parentKey); // If we've already seen this parent, than it is shared
            // with a previous column. If the current column is taller
            // than the previous column, than we need to shift the parent
            // in the previous column so it's level with the current column.

            if (seen.has(parent)) {
              parent.colspan++;

              var _seen$get = seen.get(parent),
                  _column2 = _seen$get.column,
                  index = _seen$get.index;

              if (index > col.length) {
                break;
              }

              for (var _i3 = index; _i3 < col.length; _i3++) {
                _column2.splice(_i3, 0, null);
              } // Adjust shifted indices


              for (var _i4 = col.length; _i4 < _column2.length; _i4++) {
                if (_column2[_i4] && seen.has(_column2[_i4])) {
                  seen.get(_column2[_i4]).index = _i4;
                }
              }
            } else {
              parent.colspan = 1;
              col.push(parent);
              seen.set(parent, {
                column: col,
                index: col.length - 1
              });
            }

            parentKey = parent.parentKey;
          }

          columns.push(col);
          _column.index = columns.length - 1;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var maxLength = Math.max.apply(Math, _toConsumableArray(columns.map(function (c) {
        return c.length;
      })));
      var headerRows = Array(maxLength).fill(0).map(function () {
        return [];
      }); // Convert columns into rows.

      var colIndex = 0;

      for (var _i = 0, _columns = columns; _i < _columns.length; _i++) {
        var column = _columns[_i];

        var _i2 = maxLength - 1;

        var _iterator6 = _createForOfIteratorHelper(column),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var item = _step6.value;

            if (item) {
              // Fill the space up until the current column with a placeholder
              var row = headerRows[_i2];
              var rowLength = row.reduce(function (p, c) {
                return p + c.colspan;
              }, 0);

              if (rowLength < colIndex) {
                var placeholder = {
                  type: 'placeholder',
                  key: 'placeholder-' + item.key,
                  colspan: colIndex - rowLength,
                  index: rowLength,
                  value: null,
                  rendered: null,
                  level: _i2,
                  hasChildNodes: false,
                  childNodes: [],
                  textValue: null
                };

                if (row.length > 0) {
                  row[row.length - 1].nextKey = placeholder.key;
                  placeholder.prevKey = row[row.length - 1].key;
                }

                row.push(placeholder);
                this.keyMap.set(placeholder.key, placeholder);
              }

              if (row.length > 0) {
                row[row.length - 1].nextKey = item.key;
                item.prevKey = row[row.length - 1].key;
              }

              item.level = _i2;
              item.index = colIndex;
              row.push(item);
            }

            _i2--;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        colIndex++;
      } // Add placeholders at the end of each row that is shorter than the maximum


      var i = 0;

      var _iterator7 = _createForOfIteratorHelper(headerRows),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _row = _step7.value;

          var _rowLength = _row.reduce(function (p, c) {
            return p + c.colspan;
          }, 0);

          if (_rowLength < this.columns.length) {
            var _placeholder = {
              type: 'placeholder',
              key: 'placeholder-' + _row[_row.length - 1].key,
              colspan: this.columns.length - _rowLength,
              index: _rowLength,
              value: null,
              rendered: null,
              level: i,
              hasChildNodes: false,
              childNodes: [],
              textValue: null,
              prevKey: _row[_row.length - 1].key
            };

            _row.push(_placeholder);

            this.keyMap.set(_placeholder.key, _placeholder);
          }

          i++;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return headerRows.map(function (childNodes, index) {
        var row = {
          type: 'headerrow',
          key: 'headerrow-' + index,
          index: index,
          value: null,
          rendered: null,
          level: 0,
          hasChildNodes: true,
          childNodes: childNodes,
          textValue: null
        };

        _this2.keyMap.set(row.key, row);

        return row;
      });
    }
  }, {
    key: $d7f61bffc1886b961473c48c52f8fd$var$_Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this.body.childNodes, "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return _toConsumableArray(this.body.childNodes).length;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);
      return node ? node.prevKey : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);
      return node ? node.nextKey : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var _;

      return (_ = _toConsumableArray(this.body.childNodes)[0]) == null ? void 0 : _.key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var _rows;

      var rows = _toConsumableArray(this.body.childNodes);

      return (_rows = rows[rows.length - 1]) == null ? void 0 : _rows.key;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.keyMap.get(key);
    }
  }]);

  return $d7f61bffc1886b961473c48c52f8fd$export$TableCollection;
}();

var $ed569ec24a699f43593e019ef637b788$var$OPPOSITE_SORT_DIRECTION = {
  ascending: 'descending',
  descending: 'ascending'
};
export function useTableState(props) {
  var selectionState = useMultipleSelectionState(props);
  var disabledKeys = useMemo(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);
  var context = useMemo(function () {
    return {
      showSelectionCheckboxes: props.showSelectionCheckboxes && selectionState.selectionMode !== 'none',
      selectionMode: selectionState.selectionMode,
      columns: []
    };
  }, [props.children, props.showSelectionCheckboxes, selectionState.selectionMode]);
  var collection = useCollection(props, function (nodes, prev) {
    return new $d7f61bffc1886b961473c48c52f8fd$export$TableCollection(nodes, prev, context);
  }, context); // Reset focused key if that item is deleted from the collection.

  useEffect(function () {
    if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
      selectionState.setFocusedKey(null);
    }
  }, [collection, selectionState.focusedKey]);
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: new SelectionManager(collection, selectionState),
    showSelectionCheckboxes: props.showSelectionCheckboxes || false,
    sortDescriptor: props.sortDescriptor,
    sort: function sort(columnKey) {
      var _props$sortDescriptor;

      props.onSortChange({
        column: columnKey,
        direction: ((_props$sortDescriptor = props.sortDescriptor) == null ? void 0 : _props$sortDescriptor.column) === columnKey ? $ed569ec24a699f43593e019ef637b788$var$OPPOSITE_SORT_DIRECTION[props.sortDescriptor.direction] : 'ascending'
      });
    }
  };
}

function $d2418fd9c90ca8bee81eaa89f5a574$var$TableHeader(props) {
  // eslint-disable-line @typescript-eslint/no-unused-vars
  return null;
}

$d2418fd9c90ca8bee81eaa89f5a574$var$TableHeader.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var children, columns, _iterator8, _step8, column, _columns2;

  return _regeneratorRuntime.wrap(function getCollectionNode$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          children = props.children, columns = props.columns;

          if (!(typeof children === 'function')) {
            _context2.next = 23;
            break;
          }

          if (columns) {
            _context2.next = 4;
            break;
          }

          throw new Error('props.children was a function but props.columns is missing');

        case 4:
          _iterator8 = _createForOfIteratorHelper(columns);
          _context2.prev = 5;

          _iterator8.s();

        case 7:
          if ((_step8 = _iterator8.n()).done) {
            _context2.next = 13;
            break;
          }

          column = _step8.value;
          _context2.next = 11;
          return {
            type: 'column',
            value: column,
            renderer: children
          };

        case 11:
          _context2.next = 7;
          break;

        case 13:
          _context2.next = 18;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](5);

          _iterator8.e(_context2.t0);

        case 18:
          _context2.prev = 18;

          _iterator8.f();

          return _context2.finish(18);

        case 21:
          _context2.next = 26;
          break;

        case 23:
          _columns2 = [];

          _react.Children.forEach(children, function (column) {
            _columns2.push({
              type: 'column',
              element: column
            });
          });

          return _context2.delegateYield(_columns2, "t1", 26);

        case 26:
        case "end":
          return _context2.stop();
      }
    }
  }, getCollectionNode, null, [[5, 15, 18, 21]]);
}); // We don't want getCollectionNode to show up in the type definition

export var TableHeader = $d2418fd9c90ca8bee81eaa89f5a574$var$TableHeader;

function $d42e37bea5d5623bad371e2dcbdc40c5$var$TableBody(props) {
  // eslint-disable-line @typescript-eslint/no-unused-vars
  return null;
}

$d42e37bea5d5623bad371e2dcbdc40c5$var$TableBody.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var children, items;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          children = props.children, items = props.items;
          _context4.next = 3;
          return {
            type: 'body',
            hasChildNodes: true,
            props: props,
            childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
              var _iterator9, _step9, item, _items;

              return _regeneratorRuntime.wrap(function childNodes$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!(typeof children === 'function')) {
                        _context3.next = 22;
                        break;
                      }

                      if (items) {
                        _context3.next = 3;
                        break;
                      }

                      throw new Error('props.children was a function but props.items is missing');

                    case 3:
                      _iterator9 = _createForOfIteratorHelper(items);
                      _context3.prev = 4;

                      _iterator9.s();

                    case 6:
                      if ((_step9 = _iterator9.n()).done) {
                        _context3.next = 12;
                        break;
                      }

                      item = _step9.value;
                      _context3.next = 10;
                      return {
                        type: 'item',
                        value: item,
                        renderer: children
                      };

                    case 10:
                      _context3.next = 6;
                      break;

                    case 12:
                      _context3.next = 17;
                      break;

                    case 14:
                      _context3.prev = 14;
                      _context3.t0 = _context3["catch"](4);

                      _iterator9.e(_context3.t0);

                    case 17:
                      _context3.prev = 17;

                      _iterator9.f();

                      return _context3.finish(17);

                    case 20:
                      _context3.next = 25;
                      break;

                    case 22:
                      _items = [];

                      _react.Children.forEach(children, function (item) {
                        _items.push({
                          type: 'item',
                          element: item
                        });
                      });

                      return _context3.delegateYield(_items, "t1", 25);

                    case 25:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, childNodes, null, [[4, 14, 17, 20]]);
            })
          };

        case 3:
        case "end":
          return _context4.stop();
      }
    }
  }, getCollectionNode);
}); // We don't want getCollectionNode to show up in the type definition

export var TableBody = $d42e37bea5d5623bad371e2dcbdc40c5$var$TableBody;

function $fe0a8908dd4d1a483485d151a57a1f$var$Column(props) {
  // eslint-disable-line @typescript-eslint/no-unused-vars
  return null;
}

$fe0a8908dd4d1a483485d151a57a1f$var$Column.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var title, children, childColumns, fullNodes, updateContext;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          title = props.title, children = props.children, childColumns = props.childColumns;
          _context6.next = 3;
          return {
            type: 'column',
            hasChildNodes: !!childColumns || title && _react.Children.count(children) > 0,
            rendered: title || children,
            props: props,
            childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
              var _iterator10, _step10, child, _childColumns;

              return _regeneratorRuntime.wrap(function childNodes$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      if (!childColumns) {
                        _context5.next = 20;
                        break;
                      }

                      _iterator10 = _createForOfIteratorHelper(childColumns);
                      _context5.prev = 2;

                      _iterator10.s();

                    case 4:
                      if ((_step10 = _iterator10.n()).done) {
                        _context5.next = 10;
                        break;
                      }

                      child = _step10.value;
                      _context5.next = 8;
                      return {
                        type: 'column',
                        value: child
                      };

                    case 8:
                      _context5.next = 4;
                      break;

                    case 10:
                      _context5.next = 15;
                      break;

                    case 12:
                      _context5.prev = 12;
                      _context5.t0 = _context5["catch"](2);

                      _iterator10.e(_context5.t0);

                    case 15:
                      _context5.prev = 15;

                      _iterator10.f();

                      return _context5.finish(15);

                    case 18:
                      _context5.next = 24;
                      break;

                    case 20:
                      if (!title) {
                        _context5.next = 24;
                        break;
                      }

                      _childColumns = [];

                      _react.Children.forEach(children, function (child) {
                        _childColumns.push({
                          type: 'column',
                          element: child
                        });
                      });

                      return _context5.delegateYield(_childColumns, "t1", 24);

                    case 24:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, childNodes, null, [[2, 12, 15, 18]]);
            }),
            shouldInvalidate: function shouldInvalidate(newContext) {
              // This is a bit of a hack, but it works.
              // If this method is called, then there's a cached version of this node available.
              // But, we need to keep the list of columns in the new context up to date.
              updateContext(newContext);
              return false;
            }
          };

        case 3:
          fullNodes = _context6.sent;

          updateContext = function updateContext(context) {
            // register leaf columns on the context so that <Row> can access them
            var _iterator11 = _createForOfIteratorHelper(fullNodes),
                _step11;

            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var node = _step11.value;

                if (!node.hasChildNodes) {
                  context.columns.push(node);
                }
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
          };

          updateContext(context);

        case 6:
        case "end":
          return _context6.stop();
      }
    }
  }, getCollectionNode);
}); // We don't want getCollectionNode to show up in the type definition

export var Column = $fe0a8908dd4d1a483485d151a57a1f$var$Column;

function $a7c409b25db03fac671ec6ef75bead$var$Row(props) {
  // eslint-disable-line @typescript-eslint/no-unused-vars
  return null;
}

$a7c409b25db03fac671ec6ef75bead$var$Row.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var childItems, children, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          childItems = props.childItems, children = props.children, textValue = props.textValue;
          _context8.next = 3;
          return {
            type: 'item',
            props: props,
            textValue: textValue,
            'aria-label': props['aria-label'],
            hasChildNodes: true,
            childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
              var _iterator12, _step12, column, cells, _iterator13, _step13, child;

              return _regeneratorRuntime.wrap(function childNodes$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      if (!(context.showSelectionCheckboxes && context.selectionMode !== 'none')) {
                        _context7.next = 3;
                        break;
                      }

                      _context7.next = 3;
                      return {
                        type: 'cell',
                        key: 'header',
                        // this is combined with the row key by CollectionBuilder
                        props: {
                          isSelectionCell: true
                        }
                      };

                    case 3:
                      if (!(typeof children === 'function')) {
                        _context7.next = 23;
                        break;
                      }

                      _iterator12 = _createForOfIteratorHelper(context.columns);
                      _context7.prev = 5;

                      _iterator12.s();

                    case 7:
                      if ((_step12 = _iterator12.n()).done) {
                        _context7.next = 13;
                        break;
                      }

                      column = _step12.value;
                      _context7.next = 11;
                      return {
                        type: 'cell',
                        element: children(column.key),
                        key: column.key // this is combined with the row key by CollectionBuilder

                      };

                    case 11:
                      _context7.next = 7;
                      break;

                    case 13:
                      _context7.next = 18;
                      break;

                    case 15:
                      _context7.prev = 15;
                      _context7.t0 = _context7["catch"](5);

                      _iterator12.e(_context7.t0);

                    case 18:
                      _context7.prev = 18;

                      _iterator12.f();

                      return _context7.finish(18);

                    case 21:
                      _context7.next = 28;
                      break;

                    case 23:
                      cells = [];

                      _react.Children.forEach(children, function (cell) {
                        cells.push({
                          type: 'cell',
                          element: cell
                        });
                      });

                      if (!(cells.length !== context.columns.length)) {
                        _context7.next = 27;
                        break;
                      }

                      throw new Error("Cell count must match column count. Found " + cells.length + " cells and " + context.columns.length + " columns.");

                    case 27:
                      return _context7.delegateYield(cells, "t1", 28);

                    case 28:
                      if (!childItems) {
                        _context7.next = 46;
                        break;
                      }

                      _iterator13 = _createForOfIteratorHelper(childItems);
                      _context7.prev = 30;

                      _iterator13.s();

                    case 32:
                      if ((_step13 = _iterator13.n()).done) {
                        _context7.next = 38;
                        break;
                      }

                      child = _step13.value;
                      _context7.next = 36;
                      return {
                        type: 'item',
                        value: child
                      };

                    case 36:
                      _context7.next = 32;
                      break;

                    case 38:
                      _context7.next = 43;
                      break;

                    case 40:
                      _context7.prev = 40;
                      _context7.t2 = _context7["catch"](30);

                      _iterator13.e(_context7.t2);

                    case 43:
                      _context7.prev = 43;

                      _iterator13.f();

                      return _context7.finish(43);

                    case 46:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, childNodes, null, [[5, 15, 18, 21], [30, 40, 43, 46]]);
            }),
            shouldInvalidate: function shouldInvalidate(newContext) {
              // Invalidate all rows if the columns changed.
              return newContext.columns.length !== context.columns.length || newContext.columns.some(function (c, i) {
                return c.key !== context.columns[i].key;
              }) || newContext.showSelectionCheckboxes !== context.showSelectionCheckboxes || newContext.selectionMode !== context.selectionMode;
            }
          };

        case 3:
        case "end":
          return _context8.stop();
      }
    }
  }, getCollectionNode);
}); // We don't want getCollectionNode to show up in the type definition

export var Row = $a7c409b25db03fac671ec6ef75bead$var$Row;

function $e2fd505f0e5b23b70534674763d176d$var$Cell(props) {
  // eslint-disable-line @typescript-eslint/no-unused-vars
  return null;
}

$e2fd505f0e5b23b70534674763d176d$var$Cell.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var children, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          children = props.children;
          textValue = props.textValue || (typeof children === 'string' ? children : '') || props['aria-label'] || '';
          _context9.next = 4;
          return {
            type: 'cell',
            props: props,
            rendered: children,
            textValue: textValue,
            'aria-label': props['aria-label'],
            hasChildNodes: false
          };

        case 4:
        case "end":
          return _context9.stop();
      }
    }
  }, getCollectionNode);
}); // We don't want getCollectionNode to show up in the type definition

export var Cell = $e2fd505f0e5b23b70534674763d176d$var$Cell;